document.addEventListener("DOMContentLoaded", () => {
    let tagContainers = document.querySelectorAll('.c-news-categories__items');

    if(tagContainers){
        tagContainers.forEach((container) => {
            let activeTagsCount = container.querySelectorAll('.active.filter').length;
            let currentId = container.dataset.uid;
            let countSpan = document.querySelector('.o-accordion__item-header[data-uid="' + currentId + '"] .count');

            if(activeTagsCount > 0 && countSpan){
                countSpan.innerText = activeTagsCount;
                countSpan.classList.add('visible');
            }
        });
    }
});